import { useState, type ReactNode } from 'react';
import { api } from '../api';
import { useAsyncData } from '../useAsyncData';
import type { HistoryListResponse } from '../types';
import { EmptyBox, ErrorBox, Loading } from '../components/Feedback';
import { HistoryList } from '../components/HistoryList';

export interface HistoryPageProps {
  revision: number;
}

const LIMITS = [50, 100, 200, 500] as const;

export function HistoryPage({ revision }: HistoryPageProps): ReactNode {
  const [limit, setLimit] = useState<number>(100);

  const state = useAsyncData(
    () => api.get<HistoryListResponse>('/api/history', { limit }),
    [limit, revision],
  );

  const entries = state.data?.entries ?? [];

  return (
    <div className="page">
      <div className="board-toolbar">
        <div className="toolbar-left">
          <h2 className="page-title">Historie</h2>
          <span className="muted small">Neueste Änderungen zuerst</span>
        </div>
        <div className="toolbar-right">
          <label className="inline-field">
            <span>Einträge</span>
            <select value={limit} onChange={(event) => setLimit(Number(event.target.value))}>
              {LIMITS.map((value) => (
                <option key={value} value={value}>
                  {value}
                </option>
              ))}
            </select>
          </label>
          <button
            type="button"
            className="button button-ghost button-small"
            onClick={() => state.reload()}
            disabled={state.loading}
          >
            Aktualisieren
          </button>
        </div>
      </div>

      {state.error !== null && <ErrorBox message={state.error} onRetry={() => state.reload()} />}
      {state.loading && state.data === null && <Loading label="Historie laden …" />}
      {!state.loading && state.error === null && entries.length === 0 && (
        <EmptyBox text="Noch keine Einträge vorhanden." />
      )}
      {entries.length > 0 && <HistoryList entries={entries} />}
    </div>
  );
}
